// extracted by mini-css-extract-plugin
export default {"description":"styles_description__9cwKT","description__title":"styles_description__title__ENc5S"};